// All user related database operations can be defined here.

import http from "../http-common";

class ClincialAnalyticsDataService {
  getAnalytics(formId: string, args: any) {
    return http.get(`formstatistics/${formId}?timeframe=${args.timeframe}&accessType=${args.accessType}&patientCode=${args.patientCode}`, { withCredentials: true })
  }
  getPatientFilter() {
    return http.get(`formstatistics/patients-filter`, { withCredentials: true })
  }
}

const datservice = new ClincialAnalyticsDataService();

export default datservice;
